import { Route } from '@angular/router';
import { UserRouteAccessService } from '../shared/index';
import { RejoindreDossierComponent } from './steps/rejoindre-dossier/rejoindre-dossier.component';
import { RattachementComponent } from './rattachement.component';
import { AvertissementsComponent } from './steps/avertissements/avertissements.component';
import { ConfirmationComponent } from './steps/confirmation/confirmation.component';
import { NavBackGuard } from '../shared/guards/nav-back.guard';
import { ROUTES_NAMES, PAGES_TITLES } from './rattachement.model';

export const RATTACHEMENT_ROUTE: Route = {
    path: 'rattachement',
    component: RattachementComponent,
    children: [
        {
            path: '',
            redirectTo: ROUTES_NAMES.AVERTISSEMENTS,
            pathMatch: 'full'
        },
        {
            path: ROUTES_NAMES.AVERTISSEMENTS,
            component: AvertissementsComponent,
            data: {
                needAuthentication: true,
                pageTitle: PAGES_TITLES.AVERTISSEMENTS
            },
            canActivate: [UserRouteAccessService]
        },
        {
            path: ROUTES_NAMES.REJOINDRE_DOSSIER,
            component: RejoindreDossierComponent,
            data: {
                needAuthentication: true,
                pageTitle: PAGES_TITLES.REJOINDRE_DOSSIER
            },
            canActivate: [UserRouteAccessService]
        },
        {
            path: ROUTES_NAMES.CONFIRMATION,
            component: ConfirmationComponent,
            data: {
                needAuthentication: true,
                pageTitle: PAGES_TITLES.CONFIRMATION
            },
            canActivate: [UserRouteAccessService],
            canDeactivate: [NavBackGuard]
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/rattachement/rattachement.route.ts